import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import api from 'api';
import * as storageUtils from 'utils/storageUtils';
import CardsList from './components/CardsList/CardsList';
import JsDialog from './components/JsDialog/JsDialog';

import './Accounts.css';

class Accounts extends Component {
  constructor() {
    super();

    this.state = {
      jsDialogOpen: false,
    };

    _.bindAll(this, [
      'onButtonClick',
      'handleJsDialogOpen',
      'handleJsDialogClose',
    ]);
  }

  componentDidUpdate() {
    this.saveConnectedSourcesStatus();
  }

  handleJsDialogOpen() {
    this.setState({ jsDialogOpen: true });
  }

  handleJsDialogClose() {
    this.setState({ jsDialogOpen: false });
  }

  onButtonClick(cardProps) {
    const { type } = cardProps;
    if (type === 'connect') this.handleConnect(cardProps);
    else if (type === 'javascript') this.handleJavascript(cardProps);
  }

  handleConnect(cardProps) {
    const { onError, url, urlName } = cardProps;

    api.request({ url })
      .then(
        response => window.location.href = response.data[urlName],
        response => {
          if (onError) {
            onError(response.statusText
            || '<p>Oops, there was an error in communications between our back-end and the OAuth server.<br/>Our engineers will look into that.<br/>Try again.</p>');
          }
        },
      );
  }

  handleJavascript() {
    this.handleJsDialogOpen();
  }

  saveConnectedSourcesStatus() {
    const { user: { id } } = this.props;
    const isConnected = this.getUserConnectedStatus();
    if (isConnected) return false;
    if (this.isAnySourceConnected()) storageUtils.pushItem(storageUtils.CONNECTION_STATUS, id);
  }

  getUserConnectedStatus() {
    const { user: { id } } = this.props;
    if (!id) return false;
    const allConnections = storageUtils.getArray(storageUtils.CONNECTION_STATUS);
    return allConnections.includes(id);
  }

  isAnySourceConnected() {
    const crms = this.getCrm();
    return !!crms.length;
  }

  getCrm() {
    const { user, users } = this.props;
    let crms = _.get(user, 'crms', []);
    if (users.length) crms = [...crms, 'javascript'];
    return crms;
  }

  render() {
    const { jsDialogOpen } = this.state;
    const { user, info } = this.props;
    const crms = this.getCrm();

    return (
      <Fragment>
        <CardsList
          cards={info}
          crms={crms}
          onClick={this.onButtonClick}
        />

        <JsDialog
          open={jsDialogOpen}
          handleClose={this.handleJsDialogClose}
          user={user}
        />
      </Fragment>
    );
  }
}

Accounts.propTypes = {
  user: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  info: PropTypes.array.isRequired,
};

export default Accounts;



// WEBPACK FOOTER //
// ./src/components/common/accounts/Accounts.jsx